<template>
  <path
    d="M8.11997 9.29018L12 13.1702L15.88 9.29018C16.27 8.90018 16.9 8.90018 17.29 9.29018C17.68 9.68018 17.68 10.3102 17.29 10.7002L12.7 15.2902C12.31 15.6802 11.68 15.6802 11.29 15.2902L6.69997 10.7002C6.30997 10.3102 6.30997 9.68018 6.69997 9.29018C7.08997 8.91018 7.72997 8.90018 8.11997 9.29018Z"
  />
</template>
